import { ComponentRequired, Layout, LayoutTag } from '@app/@core/@models/advertising/layout/layout.model';
import {LayoutComponent} from '@app/@core/@models/advertising/layout/layout-component.model';
import { Creative } from '@app/@core/@models/advertising/creative.model';

export type AspectRatio = 'VERTICAL_9X16' | 'NEAR_SQUARE_VERTICAL_4X5' | 'SQUARE_1X1' | 'NEAR_SQUARE_5X4' | 'SCREEN_4X3'
  | 'PHOTO_3X2' | 'WIDE_RECTANGLE_8X5' | 'WIDESCREEN_16X9' | 'HORIZONTAL_1_91X1' | 'WIDE_2X1' | 'VERY_WIDE_3X1' | 'SUPER_WIDE_6X1';

export type Dimensions = {
  width: number;
  height: number;
}

export type AspectRatioDimensions = Record<AspectRatio, Dimensions>;

export const PREVIEW_ASPECT_RATIO_DIMS: AspectRatioDimensions = {
  SQUARE_1X1: { width: 300, height: 400 },
  VERY_WIDE_3X1: { width: 600, height: 300 },
  PHOTO_3X2: { width: 600, height: 500 },
  SCREEN_4X3: { width: 400, height: 400 },
  VERTICAL_9X16: {width: 300, height: 650 },
  NEAR_SQUARE_VERTICAL_4X5: {width: 400, height: 600},
  NEAR_SQUARE_5X4: {width: 500, height: 500},
  WIDESCREEN_16X9: {width: 550, height: 400},
  WIDE_RECTANGLE_8X5: {width: 400, height: 350},
  HORIZONTAL_1_91X1: {width: 200, height: 200},
  WIDE_2X1: {width: 400, height: 300},
  SUPER_WIDE_6X1: {width: 600, height: 200},
};

export const DEFAULT_ASPECT_RATIOS: AspectRatioDimensions = {
  SQUARE_1X1: { width: 1, height: 1 },
  VERY_WIDE_3X1: { width: 3, height: 1 },
  PHOTO_3X2: { width: 3, height: 2 },
  SCREEN_4X3: { width: 4, height: 3 },
  VERTICAL_9X16: {width: 9, height: 16 },
  NEAR_SQUARE_VERTICAL_4X5: {width: 4, height: 5},
  NEAR_SQUARE_5X4: {width: 5, height: 4},
  WIDESCREEN_16X9: {width: 16, height: 9},
  WIDE_RECTANGLE_8X5: {width: 8, height: 5},
  HORIZONTAL_1_91X1: {width: 1.91, height: 1},
  WIDE_2X1: {width: 2, height: 1},
  SUPER_WIDE_6X1: {width: 6, height: 1},
};


export function deriveDimensions(creative: Creative, layout: Layout): Dimensions {
  const aspectRatioLc = layout.layoutComponents.find((lc) => {
    if ('aspectRatio' in lc) {
      const updated = lc as AssetComponent;
      const aspectRatio = updated.aspectRatio;
      return aspectRatio && lc.tag === 'image' && PREVIEW_ASPECT_RATIO_DIMS[aspectRatio];
    }
    return false;
  }) as AssetComponent | unknown;
  let width = creative.width!;
  let height = creative.height!;

  if (layout.layoutType === 'NATIVE' && aspectRatioLc) {
    const updated = aspectRatioLc as AssetComponent;
    const aspectRatio = updated.aspectRatio;
    if (aspectRatio) {
      width = PREVIEW_ASPECT_RATIO_DIMS[aspectRatio].width;
      height = PREVIEW_ASPECT_RATIO_DIMS[aspectRatio].height;
    }
  }
  return {width: width, height: height}
}

// ng.model.layout.AssetComponent
export interface AssetComponent {
  tag: LayoutTag
  type: 'ASSET'
  mimeTypes: string[]
  maxFileSizeBytes: number
  aspectRatio?: AspectRatio
  name?: string
  required: ComponentRequired
}

export function isAssetComponent(layoutComponent:LayoutComponent): layoutComponent is AssetComponent {
  return (layoutComponent.type === 'ASSET');
}

